import {
  REQUEST_ERROR_HIDE,
  REQUEST_APPEAL_ERROR,
  REQUEST_APPEAL_ALREADY_REPORTED,
  NOT_CORRECT_EXAM_FORM_SUBMIT_ERROR,
  FAILURE_EXAM_DATA,
  FAILURE_USER_DATA
} from '../constants';

const initialState = {
  error: null,
  show: false,
  typeError: null,
  requestCausedError: null
};

const requestError = (state = initialState, action) => {
  switch (action.type) {
    case NOT_CORRECT_EXAM_FORM_SUBMIT_ERROR:
    case FAILURE_EXAM_DATA:
      return {
        ...state,
        show: true,
        error: action.error,
        typeError: null
      };
    case FAILURE_USER_DATA:
      return {
        ...state,
        show: true,
        error: action.error,
        typeError: 'ErrorGetUserData'
      };
    /**
     * это событие реагирует только на ошибку отправки апелляции
     */
    case REQUEST_APPEAL_ERROR:
      return {
        ...state,
        show: true,
        error: action.error,
        typeError: 'ErrorSendAppeal'
      };
    /**
     * это событие на ответ отправки апелляции 208 - уже подавалось
     */
    case REQUEST_APPEAL_ALREADY_REPORTED:
      return {
        ...state,
        show: true,
        error: action.error,
        typeError: 'RequestAppealAlreadyReported',
        requestCausedError: action.payload
      };
    case REQUEST_ERROR_HIDE:
      return initialState;
    default:
      return state;
  }
};

export default requestError;
